export type SortBy = { keyPath: string; value: 'ASC' | 'DESC' };

export type SortOptions = SortBy & {
  fallback?: string;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getSortCompareFn = (sortBy: SortOptions) => (itemA: any, itemB: any) => {
  const { keyPath, value, fallback } = sortBy;
  let sortedValue = 0;

  const valueA = getKeyPath(itemA, keyPath);
  const valueB = getKeyPath(itemB, keyPath);

  if (typeof valueA !== typeof valueB) {
    throw Error(`Values are of different type for this keyPath: ${keyPath}`);
  }

  const isBoolean = typeof valueA === 'boolean';
  const isNumber = typeof valueA === 'number' || (!isNaN(valueA) && !isBoolean);
  const isString = typeof valueA === 'string' && !isNumber;
  const isEqualOrNull = valueA === valueB || valueA === null || valueB === null;

  if (isEqualOrNull) {
    sortedValue = fallback ? parseInt(getKeyPath(itemA, fallback), 10) - parseInt(getKeyPath(itemB, fallback), 10) : 0;
  } else {
    if (isBoolean) {
      sortedValue = valueA > valueB ? -1 : 1;
    }

    if (isString) {
      sortedValue = valueA.toLowerCase() < valueB.toLowerCase() ? -1 : 1;
    }

    if (isNumber) {
      sortedValue = (valueA as number) - (valueB as number);
    }
  }

  return value === 'ASC' ? sortedValue : -sortedValue;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const getKeyPath = (object: any, keyPath: string) => {
  return keyPath.split('.').reduce((value, key) => {
    if (value === undefined) {
      return undefined;
    }

    return value[key];
  }, object);
};
